module.exports = __webpack_public_path__ + "media/images/athletes/4330-0a91cf8412800fb75b3949fea21faa92.png";